<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel" :disabled="!tableSelectedRows || tableSelectedRows.length === 0">删除</a-button>
				<a-button icon="sync" @click="apiPrintTemplateQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="打印模板查询">
				<div style="display: flex;justify-content: space-between;align-items: center;">
                    <div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">服务商：</div>
						<a-select v-model="query.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" style="width: 100%;" placeholder="请选择服务商" allowClear>
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">模板名称：</div>
						<a-input v-model="query.templateName" style="width: 100%;" placeholder="请输入名称" />
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiPrintTemplateQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						打印模板列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="printTemplateId" :loading="tableLoading" :pagination="false">
				<template slot="facilitator" slot-scope="facilitator">
					{{ facilitatorList.find(item => item.facilitatorId == facilitator.facilitatorId)?.facilitatorName || '' }}
				</template>
				<template slot="templateName" slot-scope="templateName">
					<a-button type="link" @click="tableEdit(templateName)">{{templateName.templateName || ''}}</a-button>
				</template>
			
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="800px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 20}" :rules="addRules">
				<a-form-model-item label="模板名称" has-feedback prop="templateName">
					<a-input v-model="addForm.templateName" placeholder="请输入模板名称" />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="打印参数" has-feedback>
					<div class="param-list">
						<div class="param-header">
							<div class="col-select">
								<a-checkbox
									:indeterminate="addParamStates.some(it => it.checked) && !addParamStates.every(it => it.checked)"
									:checked="addParamStates.length > 0 && addParamStates.every(it => it.checked)"
									@change="onSelectAll('addParamStates', $event.target.checked)"
								>全选</a-checkbox>
							</div>
							<div class="col-title">打印名称</div>
							<div class="col-title">自定义名称</div>
							<div class="col-title">数据序号</div>
						</div>
						<div class="param-row" v-for="item in addParamStates" :key="item.printParamId">
							<div class="col-select">
								<a-checkbox v-model="item.checked"></a-checkbox>
							</div>
							<a-input :value="item.dataTitle" disabled class="col-input" />
							<a-input v-model="item.printTitle" :disabled="!item.checked" :placeholder="item.dataTitle" class="col-input" />
							<a-input v-model="item.printCode" :disabled="!item.checked" class="col-input" placeholder="序号"/>
						</div>
					</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="800px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="模板名称" has-feedback prop="templateName">
					<a-input v-model="editForm.templateName" placeholder="请输入模板名称" />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="打印参数" has-feedback>
					<div class="param-list">
						<div class="param-header">
							<div class="col-select">
								<a-checkbox
									:indeterminate="editParamStates.some(it => it.checked) && !editParamStates.every(it => it.checked)"
									:checked="editParamStates.length > 0 && editParamStates.every(it => it.checked)"
									@change="onSelectAll('editParamStates', $event.target.checked)"
								>全选</a-checkbox>
							</div>
							<div class="col-title">打印名称</div>
							<div class="col-title">自定义名称</div>
							<div class="col-title">数据序号</div>
						</div>
						<div class="param-row" v-for="item in editParamStates" :key="item.printParamId">
							<div class="col-select">
								<a-checkbox v-model="item.checked"></a-checkbox>
							</div>
							<a-input :value="item.dataTitle" disabled class="col-input" />
							<a-input v-model="item.printTitle" :disabled="!item.checked" :placeholder="item.dataTitle" class="col-input" />
							<a-input v-model="item.printCode" :disabled="!item.checked" class="col-input" placeholder="序号"/>
						</div>
					</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 打印参数
				paramOptions: [],
                //服务商列表
				facilitatorList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					type:'f_card',
					templateName: undefined,
                    facilitatorId: undefined,
				},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'printTemplateId', key:'printTemplateId', align:'center'},
					{ title:'模板名称', key:'templateName', align:'center',scopedSlots: { customRender: 'templateName' }},
					{ title:'服务商',  key:'facilitator', align:'center',scopedSlots: { customRender: 'facilitator' }},
					{ title:'创建时间', dataIndex:'createTime', key:'createTime', align:'center'},
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: undefined,
					templateName: '',
					type:'f_card',
				},
				addParamStates: [],
				addRules: {
					templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					printTemplateId: '',
					facilitatorId: undefined,
					templateName: '',
					type:'f_card',
				},
				editParamStates: [],
				// 修改弹窗-end
			};
		},
		methods: {
            //获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			async apiPrintTemplateParams() {
				const { data: res } = await this.$http.post(this.navigation.apiPrintTemplateParams);
				if (res.code == 200) {
					this.paramOptions = res.data || []
				} else {
					this.$message.error(res.msg)
				}
			},
			buildParamStates(fromOptions, selectedList = []) {
				const selectedMap = {}
				selectedList.forEach(it => {
					selectedMap[it.printParamId] = it
				})
				return fromOptions.map(opt => {
					const sel = selectedMap[opt.printParamId]
					return {
						printParamId: opt.printParamId,
						paramName: opt.paramName || opt.dataTitle || '',
						dataTitle: opt.dataTitle || opt.paramName || '',
						printTitle: sel && sel.printTitle ? sel.printTitle : (opt.printTitle || opt.dataTitle || opt.paramName || ''),
						printCode: sel && sel.printCode ? sel.printCode : (opt.printCode || ''),
						checked: !!sel,
					}
				})
			},
			//--------------表格开始-搜索
			async apiPrintTemplateQueryList() {
				this.tableLoading = true
				const { data: res } = await this.$http.post(this.navigation.apiPrintTemplateQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPrintTemplateQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPrintTemplateQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false
			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					facilitatorId: undefined,
					templateName: '',
					type:'f_card'
				}
				this.addParamStates = this.buildParamStates(this.paramOptions)
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
			},
			collectParams(paramStates) {
				const list = paramStates.filter(it => it.checked).map(it => ({
						printParamId: it.printParamId,
						printTitle: it.printTitle,
						printCode: it.printCode,
					}))
				if(list.length > 0){
					for(let i = 0; i < list.length; i++){
						if(list[i].printCode == '' || list[i].printTitle == ''){
							this.$message.error("勾选的第" + (i+1) + "条数据,缺少参数")
							return []
						}
					}
					return list
				}
				this.$message.error("请勾选打参数")
				return []
			},
			onSelectAll(listKey, checked) {
				this[listKey] = this[listKey].map(it => ({
					...it,
					checked
				}))
			},
			async apiPrintTemplateAdd() {
				this.addConfirmLoading = true
				const checkList = this.collectParams(this.addParamStates);
				if(checkList.length > 0){
					const payload = {
						facilitatorId: this.addForm.facilitatorId,
						type:this.addForm.type,
						templateName: this.addForm.templateName,
						templateJson: JSON.stringify(checkList),
					}
					const { data: res } = await this.$http.post(this.navigation.apiPrintTemplateAdd, payload);
					if (res.code == 200) {
						this.$message.success(res.msg)
						if(this.$refs.addRuleForm) {
							this.$refs.addRuleForm.resetFields();
						}
						this.addConfirmLoading = false
						this.addVisible = false
						this.apiPrintTemplateQueryList()
					} else {
						this.$message.error(res.msg)
						this.addConfirmLoading = false
					}
				}else{
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPrintTemplateAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				// let items = JSON.parse(JSON.stringify(item))
				this.editVisible = true
				this.editForm = {
					printTemplateId: item.printTemplateId,
					facilitatorId: item.facilitatorId,
					templateName: item.templateName,
					templateJson: JSON.parse(item.templateJson) || [],
					type:'f_card'
				}
				this.editParamStates = this.buildParamStates(this.paramOptions, this.editForm.templateJson)
			},
			async apiPrintTemplateEdit() {
				this.editConfirmLoading = true
				const checkList = this.collectParams(this.editParamStates)
				if(checkList.length > 0 ){
					const payload = {
						printTemplateId: this.editForm.printTemplateId,
						facilitatorId: this.editForm.facilitatorId,
						templateName: this.editForm.templateName,
						templateJson: JSON.stringify(checkList),
						type:this.editForm.type,
					}
					const { data: res } = await this.$http.post(this.navigation.apiPrintTemplateEdit, payload);
					if (res.code == 200) {
						this.$message.success(res.msg)
						this.editConfirmLoading = false
						this.editVisible = false
						this.apiPrintTemplateQueryList()
					} else {
						this.$message.error(res.msg)
						this.editConfirmLoading = false
					}
				}else{
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPrintTemplateEdit()
					} else {
						return false;
					}
				});
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.printTemplateId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPrintTemplateDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPrintTemplateDel(ids) {
				const { data: res } = await this.$http.post(this.navigation.apiPrintTemplateDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiPrintTemplateQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit(row) {
				if(row != null){
					this.edit(row)
				}else if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.printTemplateId == this.tableSelectedRows[0].printTemplateId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
            this.apiFacilitatorList()
			this.apiPrintTemplateParams()
			this.apiPrintTemplateQueryList()
		}
	};
</script>

<style scoped>
.param-list {
	display: flex;
	flex-direction: column;
	max-height: calc(100vh - 350px);
	overflow: auto;
	padding: 8px;
	background: #fafafa;
	border: 1px solid #e8e8e8;
	border-radius: 4px;
}
.param-row {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
.param-header {
	display: flex;
	align-items: center;
	font-weight: 600;
	margin-bottom: 8px;
}
.col-select {
	width: 80px;
	display: flex;
	align-items: center;
}
.col-title {
	width: 160px;
	text-align: center;
	margin-left: 12px;
}
.col-input {
	background-color: #fff !important;
	color: rgba(0, 0, 0, 0.65) !important;
	width: 160px;
	margin-left: 12px;
}
.qa-modal ::v-deep .ant-form{
	overflow-y: auto;
}

	/* 弹窗样式 - 将滚动条设置在弹窗body层，宽度自适应 */
.qa-modal ::v-deep .ant-modal {
	width: auto !important;
	max-width: 80vw;
}

.qa-modal ::v-deep .ant-modal-content {
	background-color: #fff;
	width: auto;
}

.qa-modal ::v-deep .ant-modal-body {
	max-height: calc(100vh - 110px);
	overflow-y: auto;
	padding: 24px;
	width: auto;
	position: relative;
}

</style>